import React, { useCallback, useEffect, useState } from "react";
import {
  PROMO_CAMPAIGN,
  PROMO_CAMPAIGN_ENABLED,
} from "../../config/promoCampaign";
import PromoCampaignModal from "./PromoCampaignModal";
import {
  dismissPromoCampaign,
  isPromoCampaignDismissed,
  isPromoPendingForLogin,
  markPromoShownForLogin,
} from "./promoCampaignStorage";

/**
 * Mount inside the authenticated shell.
 * Opens only after a successful login (session flag), not on Daily Log /
 * route-sheet back-navigation that remounts MainShell, and not on refresh.
 */
const PromoCampaignHost = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!PROMO_CAMPAIGN_ENABLED) return undefined;
    if (!PROMO_CAMPAIGN?.slides?.length) return undefined;
    if (isPromoCampaignDismissed(PROMO_CAMPAIGN.id, PROMO_CAMPAIGN.version)) {
      markPromoShownForLogin();
      return undefined;
    }
    if (!isPromoPendingForLogin()) return undefined;

    const timer = window.setTimeout(() => {
      markPromoShownForLogin();
      setOpen(true);
    }, 280);
    PROMO_CAMPAIGN.slides.forEach((s) => {
      if (!s.image) return;
      const img = new Image();
      img.src = s.image;
    });
    return () => window.clearTimeout(timer);
  }, []);

  const handleClose = useCallback((persistDismiss) => {
    setOpen(false);
    markPromoShownForLogin();
    if (persistDismiss) {
      dismissPromoCampaign(PROMO_CAMPAIGN.id, PROMO_CAMPAIGN.version);
    }
  }, []);

  if (!PROMO_CAMPAIGN_ENABLED || !open) return null;

  return (
    <PromoCampaignModal campaign={PROMO_CAMPAIGN} onClose={handleClose} />
  );
};

export default PromoCampaignHost;
